import React, { useEffect, useState } from 'react';
import _ from "../../../utils/firebase";
import '../../../public/stylesheets/style-confirm.css';
import ReactDOM from 'react-dom';
import MainPage from '../../../Pages/MainPage';
import { ModelCodeSecretFeature } from '../../classcomponent/modelCodeSecretFeature';
import SerialCodeFeature from '../../../Pages/SerialCodeFeatureCode';

function EditCodeSecretFeature () {
    
    const [_member , setMember] = useState('');
    const [_description , setDescription] = useState('');

    const UpdateCode = async (e) => {
        
        e.preventDefault();

        const id = ModelCodeSecretFeature.prototype.id;

        let _modelMember = null;
        _member === undefined ? _modelMember = ModelCodeSecretFeature.prototype.member : _modelMember = _member;
        
        await _.secret_code.doc(id).update({
            description:_description
        });

        CloseFormEditDataToRelode();
    }

    const CloseFormEditDataToRelode = () => {

        var _form = document.getElementById('formEditDataSecreFeature');
        _form.style.top = '-100%';

        refreshPage();

    }

    const CloseFormEditData = () => {

        var _form = document.getElementById('formEditDataSecreFeature');
        _form.style.top = '-100%';

    }

    const refreshPage = () => {

        setTimeout(() => {

            ReactDOM.render(<MainPage pages={''}/> , document.getElementById('root'));
            ReactDOM.render(<MainPage pages={<SerialCodeFeature/>}/> , document.getElementById('root'));
            
        },500);

    }
    
    return(

        <div className='formEditData' id='formEditDataSecreFeature'>
            <div className='box-data'>

                <div className='text-white'>
                    <h1 >แก้ไขข้อมูลฟีเจอร์ลับ</h1>
                </div>
                <div className='form-input'>
                    <span>ผู้ใช้งาน</span>
                    <input className='form-control' id={'_edmember'} type='text' readOnly></input>
                </div>
                <div className='form-input'>
                    <span>รหัสโค้ด</span>
                    <input className='form-control' id={'_edcode'} type='number' readOnly></input>
                </div>
                 <div className='form-input'>
                    <span>สถานะการใช้งาน</span>
                    <input className='form-control' id={'_edstatus'} type='text'  readOnly></input>
                   
                </div>
                <div className='form-input'>
                    <span>เวลาหมดอายุ</span>
                    <input className='form-control' id={'_edexpire'} type='text'  readOnly></input>
                </div>
                <div className='form-input'>
                        <span>หมายเหตุ</span>
                        <input className='form-control' id={'_edescription'} type='text' onChange={(e) => setDescription(e.target.value)}></input>
                </div>
                <div className='form-input-btn'>
                    <div className='form-btn'>
                        <button className='btn btncreate' type='submit' onClick={UpdateCode}>ยืนยัน</button>
                        <button className='btn btncancel' onClick={CloseFormEditData}>ยกเลิก</button>
                    </div>                   
                </div> 
            </div>
        </div>
    )

}


export default EditCodeSecretFeature;